import { Provider } from '@angular/core';

import { CertificatesRepositoryImpl } from '@app/data/repositories/ptrab/certificates/certificates.repository';
import { CERTIFICATES_REPOSITORY } from '@app/domain/repositories/ptrab/certificates/certificates.repository.contract';

export const certificatesRepositoryProvider: Provider = {
  provide: CERTIFICATES_REPOSITORY,
  useClass: CertificatesRepositoryImpl
};
